 import { styled } from "@mui/material/styles";

 const StyledEditBusinessOverview = styled("div")(
   ({ theme }) => `
    .signup-textfeilds {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .signup-store {
      display: flex;
      gap: 20px;
      @media screen and (max-width: 480px) {
        flex-direction: column;
      }  
    }  
    .text-feilds {
      width: 100%;
    }
    .edit-business-overview-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 20px;
      font-style: normal;
      line-height: 100%;
      margin-bottom: 10px;
    }  
  
  `
 );

 export default StyledEditBusinessOverview;
